/* eslint-disable implicit-arrow-linebreak */
import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';

export const RDIMS_ACTIONS = {
  SET_SELECTED_RDIMS: '@regulatory/rdims/setSelectedRdims',
  TOGGLE_MY_LOCKS_FAX_id: '@regulatory/rdims/toggleMylocks',
  TOGGLE_LOCK_UNlOCK: '@regulatory/rdims/toggleLockBtn',
  TOGGLE_PACKET_LOCK_UNlOCK: '@regulatory/rdims/togglePacketLockBtn'
};

export const setSelectedRdims = (data, index) => (dispatch) => {
  const action = {
    type: RDIMS_ACTIONS.SET_SELECTED_RDIMS,
    payload: {
      data,
      index
    }
  };
  dispatch(action);
};

export const toggleLockBtn = (token, loggerInfo, postBody) => (dispatch) =>
  http.putWithToken(`regulatory-data-service/v1/rdims/id/${postBody.id}/lockstatus`, token, JSON.stringify(postBody), loggerInfo)
    .pipe(
      map((resp) => {
        const action = {
          type: RDIMS_ACTIONS.TOGGLE_PACKET_LOCK_UNlOCK,
          payload: postBody.lockedBy
        };
        dispatch(action);
        return resp;
      })
    );

export const deleteRdims = (token, loggerInfo, rdimsId) => () =>
  http.deleteWithToken(`regulatory-data-service/v1/rdims/id/${rdimsId}`, token, loggerInfo).pipe(map((resp) => resp));

export const createPacket = (token, loggerInfo, packetData) => () =>
  http
    .postWithToken(`regulatory-data-service/v1/rdims/packet`, token, JSON.stringify(packetData), loggerInfo)
    .pipe(map((resp) => resp));

export const saveRdims = (token, loggerInfo, id, rdimsId, postBody) => () => http
  .putWithToken(
    `regulatory-data-service/v1/rdims/id/${rdimsId}/lockstatus`,
    token,
    JSON.stringify(postBody),
    loggerInfo
  )
  .pipe(
    map(
      (resp) =>
        resp
    )
  );
